/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {savingsMoveCash} from '../api'

export const useMutationSavingsMoveCash = createReactQueryMutationHook('savingsMoveCash', savingsMoveCash)
